var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 38,
    y1: 1137.05,
    x2: 38,
    y2: 1084.7,
    gradientTransform: "translate(0 -1073.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 42.8,
    y1: 1073.21,
    x2: 37.32,
    y2: 1097.52,
    gradientTransform: "translate(0 -1073.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 38,
    y1: 592.05,
    x2: 38,
    y2: 539.7,
    gradientTransform: "translate(0 -528.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 42.8,
    y1: 528.21,
    x2: 37.32,
    y2: 552.52,
    gradientTransform: "translate(0 -528.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 28.32,
    y1: 18.95,
    x2: 46.7,
    y2: 45.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ff9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c63838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6f39c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#385ac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37d342"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 28.32,
    y1: 18.95,
    x2: 46.71,
    y2: 45.63,
    xlinkHref: "#linear-gradient-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.74,65.15c-4.65,0-8.73-3.84-8.73-8.21,0,0,.01-5.81.01-9.33,0-1.35.13-2.72,1.09-2.72.55,0,1.03.54,1.58,1.36.71,1.06,1.74,1.62,3.13,1.71.08,0,.16,0,.24,0,1,0,1.59-.41,2.38-1.22,1.23-1.26,1.29-3.47,1.35-13.67-.06-10.19-.12-12.4-1.35-13.66-.79-.81-1.37-1.22-2.38-1.22-.08,0-.16,0-.24,0-1.39.09-2.42.65-3.13,1.71-.55.82-1.02,1.36-1.58,1.36-.96,0-1.09-1.38-1.09-2.73,0-3.52-.02-9.33-.02-9.33C1.01,4.84,5.09,1,9.74,1h47.55c4.43,0,8.04,3.68,8.04,8.21,0,0,.11,9.54.11,9.75,0,3.01.92,3.01,1.81,3.01.98,0,1.31-.51,1.77-1.22.52-.8,1.18-1.8,2.92-1.8,3.01,0,3.02,4.76,3.04,11.95v2.28s0,2.08,0,2.08c-.02,7.2-.02,11.96-3.04,11.96-1.74,0-2.4-1-2.92-1.81-.46-.71-.8-1.23-1.77-1.23-.89,0-1.81,0-1.81,3.02,0,.21-.11,9.75-.11,9.75,0,4.52-3.6,8.21-8.04,8.21H9.74s0,0,0,0Z",
    style: {
      fill: "#ff61f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.29,1.5c4.16,0,7.54,3.45,7.54,7.71,0,0,.1,9.54.1,9.75,0,3.11.98,3.51,2.31,3.51,2.57,0,1.82-3.03,4.69-3.03s2.5,5.62,2.55,13.53v.2c-.05,7.91.21,13.53-2.55,13.53s-2.13-3.03-4.69-3.03c-1.33,0-2.31.4-2.31,3.51,0,.21-.1,9.75-.1,9.75,0,4.26-3.38,7.71-7.54,7.71H9.74c-4.16,0-8.23-3.45-8.23-7.71,0,0,.01-5.81.01-9.33,0-1.69.25-2.23.59-2.23.36,0,.83.63,1.16,1.14.59.87,1.59,1.81,3.51,1.93.09,0,.18,0,.27,0,1.24,0,1.94-.56,2.73-1.37,1.39-1.42,1.43-3.54,1.49-14.02-.06-10.48-.11-12.6-1.49-14.02-.79-.81-1.49-1.37-2.73-1.37-.09,0-.18,0-.27,0-1.93.12-2.93,1.06-3.51,1.93-.34.51-.8,1.14-1.16,1.14-.34,0-.59-.54-.59-2.23,0-3.52-.01-9.33-.01-9.33,0-4.26,4.06-7.71,8.23-7.71h47.55M57.29.5H9.74C4.83.5.51,4.57.51,9.21c0,0,.01,5.81.01,9.33,0,.97,0,3.23,1.59,3.23.86,0,1.48-.82,2-1.58.39-.59,1.11-1.39,2.74-1.49.07,0,.14,0,.21,0,.84,0,1.3.33,2.02,1.07,1.1,1.12,1.15,3.29,1.21,13.32-.06,10.02-.11,12.19-1.21,13.31-.72.73-1.18,1.06-2.02,1.06-.07,0-.14,0-.21,0-1.63-.1-2.35-.9-2.74-1.49-.51-.77-1.13-1.58-1.99-1.58-.31,0-1.05.12-1.38,1.19-.14.47-.21,1.14-.21,2.04,0,3.52-.01,9.33-.01,9.33,0,4.65,4.31,8.72,9.23,8.72h47.55c4.71,0,8.54-3.91,8.54-8.71,0-.38.11-9.54.11-9.75,0-2.51.55-2.51,1.31-2.51.67,0,.87.26,1.35,1,.53.81,1.32,2.03,3.34,2.03,3.51,0,3.52-4.96,3.54-12.46,0-.67,0-1.36,0-2.07v-.21c0-.69,0-1.39,0-2.08-.02-7.5-.03-12.45-3.54-12.45-2.02,0-2.81,1.22-3.34,2.03-.48.74-.68,1-1.35,1-.76,0-1.31,0-1.31-2.51,0-.21-.1-9.37-.11-9.76,0-4.79-3.83-8.7-8.54-8.7Z",
    style: {
      fill: "#ab55a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74,63.66c-3.8,0-7.25-3.2-7.25-6.72,0,0,.01-5.81.01-9.33,0-.19,0-.34,0-.49.97,1.43,2.4,2.21,4.23,2.32.11,0,.23.01.33.01,1.66,0,2.6-.82,3.42-1.66,1.7-1.74,1.71-3.98,1.78-14.71-.07-10.75-.08-12.98-1.78-14.72-.82-.84-1.76-1.66-3.42-1.66-.11,0-.22,0-.33.01-1.84.11-3.26.9-4.23,2.32,0-.16,0-.32,0-.49,0-3.52-.01-9.33-.01-9.33,0-3.52,3.46-6.72,7.25-6.72h47.55c3.62,0,6.57,3.02,6.57,6.72.03,3.3.1,9.56.1,9.75,0,3.16.98,4.5,3.27,4.5,1.77,0,2.48-1.09,3-1.89.47-.73.74-1.14,1.69-1.14,1.54,0,1.55,5.08,1.57,10.45,0,.67.01,2.28.01,2.28,0,.71-.01,1.41-.01,2.08-.01,5.37-.02,10.45-1.57,10.45-.95,0-1.22-.4-1.69-1.13-.52-.8-1.23-1.9-3-1.9-2.3,0-3.28,1.35-3.28,4.51,0,.19-.07,6.45-.1,9.73,0,3.72-2.95,6.73-6.57,6.73H9.74Z",
    style: {
      fill: "url(#linear-gradient)",
      isolation: "isolate",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74,3.9h47.55c3.62,0,6.57,3.01,6.57,6.72.03,3.3.1,9.56.1,9.75,0,3.15.98,4.5,3.27,4.5,1.77,0,2.48-1.1,3-1.9.47-.73.74-1.14,1.69-1.14,1.54,0,1.55,5.08,1.57,10.45,0,.39,0,1.1,0,1.62,0-.25,0-.49,0-.74,0,0-.01-1.61-.01-2.28-.01-5.38-.02-10.45-1.57-10.45-.95,0-1.22.4-1.69,1.14-.52.8-1.23,1.89-3,1.89-2.3,0-3.28-1.35-3.28-4.5,0-.19-.07-6.45-.1-9.75,0-3.7-2.95-6.72-6.57-6.72H9.74c-3.8,0-7.25,3.2-7.25,6.72v1.36c.03-3.5,3.47-6.67,7.25-6.67ZM2.5,49.01c0-.18,0-.34,0-.49.97,1.43,2.4,2.21,4.23,2.32.11,0,.23.01.33.01,1.66,0,2.6-.82,3.42-1.66,1.7-1.74,1.71-3.98,1.78-14.71v-.7c-.07,10.13-.12,12.31-1.78,14.01-.82.83-1.76,1.65-3.42,1.65-.11,0-.22,0-.33-.01-1.84-.11-3.26-.9-4.23-2.32,0,.16,0,.32,0,.49,0,3.52-.01,9.33-.01,9.33v.05c0-1.93.01-5.51.01-7.98Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.69
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51,19.03c.97-1.43,2.39-2.21,4.23-2.32.11,0,.23-.01.33-.01,1.66,0,2.6.82,3.42,1.66,1.61,1.65,1.71,6.12,1.77,15.42,18.04,4.05,26.21-1.79,45.28-1.79,11.38,0,8.02.69,15.97,1.91,0-.24,0-.48,0-.72,0,0-.01-1.61-.01-2.28-.01-5.38-.02-10.45-1.57-10.45-.96,0-1.22.4-1.69,1.14-.52.8-1.23,1.89-3,1.89-2.3,0-3.27-1.35-3.27-4.5,0-.19-.07-6.45-.1-9.75,0-3.7-2.95-6.72-6.57-6.72H9.74c-3.8,0-7.25,3.2-7.25,6.72,0,0,.01,5.81.01,9.33,0,.19,0,.35,0,.49Z",
    style: {
      fill: "url(#linear-gradient-2)",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74,65.15c-4.65,0-8.73-3.84-8.73-8.21,0,0,.01-5.81.01-9.33,0-1.35.13-2.72,1.09-2.72.55,0,1.03.54,1.58,1.36.71,1.06,1.74,1.62,3.13,1.71.08,0,.16,0,.24,0,1,0,1.59-.41,2.38-1.22,1.23-1.26,1.29-3.47,1.35-13.67-.06-10.19-.12-12.4-1.35-13.66-.79-.81-1.37-1.22-2.38-1.22-.08,0-.16,0-.24,0-1.39.09-2.42.65-3.13,1.71-.55.82-1.02,1.36-1.58,1.36-.96,0-1.09-1.38-1.09-2.73,0-3.52-.02-9.33-.02-9.33C1.01,4.84,5.09,1,9.74,1h47.55c4.43,0,8.04,3.68,8.04,8.21,0,0,.11,9.54.11,9.75,0,3.01.92,3.01,1.81,3.01.98,0,1.31-.51,1.77-1.22.52-.8,1.18-1.8,2.92-1.8,3.01,0,3.02,4.76,3.04,11.95v2.28s0,2.08,0,2.08c-.02,7.2-.03,11.96-3.04,11.96-1.75,0-2.4-1-2.92-1.81-.46-.71-.8-1.22-1.77-1.22-.89,0-1.81,0-1.81,3.01,0,.21-.11,9.75-.11,9.75,0,4.52-3.6,8.21-8.04,8.21H9.74Z",
    style: {
      fill: "#ff61f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.29,1.5c4.16,0,7.54,3.45,7.54,7.71,0,0,.11,9.54.11,9.75,0,3.11.98,3.51,2.31,3.51,2.57,0,1.82-3.03,4.69-3.03s2.5,5.62,2.55,13.53v.2c-.05,7.91.21,13.53-2.55,13.53s-2.13-3.03-4.69-3.03c-1.33,0-2.31.4-2.31,3.51,0,.21-.11,9.75-.11,9.75,0,4.26-3.38,7.71-7.54,7.71H9.74c-4.16,0-8.23-3.45-8.23-7.71,0,0,.01-5.81.01-9.33,0-1.69.25-2.23.59-2.23.36,0,.83.63,1.16,1.14.59.87,1.59,1.81,3.51,1.93.09,0,.18,0,.27,0,1.24,0,1.94-.56,2.73-1.37,1.39-1.42,1.43-3.54,1.49-14.02-.06-10.48-.11-12.6-1.49-14.02-.79-.81-1.49-1.37-2.73-1.37-.09,0-.18,0-.27,0-1.93.12-2.93,1.06-3.51,1.93-.34.51-.8,1.14-1.16,1.14-.34,0-.59-.54-.59-2.23,0-3.52-.01-9.33-.01-9.33,0-4.26,4.06-7.71,8.23-7.71h47.55M57.29.5H9.74C4.83.5.51,4.57.51,9.21c0,0,.01,5.81.01,9.33,0,.97,0,3.23,1.59,3.23.86,0,1.48-.82,2-1.58.39-.59,1.11-1.39,2.74-1.49.07,0,.14,0,.21,0,.84,0,1.3.33,2.02,1.07,1.1,1.12,1.15,3.29,1.21,13.32-.06,10.02-.11,12.19-1.21,13.31-.72.74-1.18,1.06-2.02,1.06-.07,0-.14,0-.21,0-1.63-.1-2.35-.9-2.74-1.49-.51-.77-1.13-1.58-1.99-1.58-.31,0-1.05.12-1.38,1.19-.14.47-.21,1.14-.21,2.04,0,3.52-.01,9.33-.01,9.33,0,4.64,4.31,8.72,9.23,8.72h47.55c4.71,0,8.54-3.91,8.54-8.71,0-.38.11-9.54.11-9.75,0-2.51.55-2.51,1.31-2.51.67,0,.87.26,1.35,1,.53.81,1.32,2.03,3.34,2.03,3.51,0,3.52-4.96,3.54-12.46,0-.67,0-1.36,0-2.07v-.21c0-.72,0-1.41,0-2.08-.02-7.5-.03-12.45-3.54-12.45-2.02,0-2.81,1.22-3.34,2.03-.48.74-.68,1-1.35,1-.76,0-1.31,0-1.31-2.51,0-.21-.1-9.37-.11-9.76,0-4.79-3.83-8.7-8.54-8.7Z",
    style: {
      fill: "#ab55a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74,63.66c-3.8,0-7.25-3.2-7.25-6.72,0,0,.01-5.81.01-9.33,0-.18,0-.34,0-.49.97,1.43,2.4,2.21,4.23,2.32.11,0,.23.01.33.01,1.66,0,2.6-.82,3.42-1.66,1.7-1.74,1.71-3.98,1.78-14.71-.07-10.75-.08-12.98-1.78-14.72-.82-.84-1.76-1.66-3.42-1.66-.11,0-.22,0-.33.01-1.84.11-3.26.9-4.23,2.32,0-.16,0-.32,0-.49,0-3.52-.01-9.33-.01-9.33,0-3.52,3.46-6.72,7.25-6.72h47.55c3.62,0,6.57,3.02,6.57,6.72.03,3.3.1,9.56.11,9.75,0,3.16.98,4.5,3.28,4.5,1.77,0,2.48-1.09,3-1.89.47-.73.74-1.14,1.69-1.14,1.54,0,1.55,5.08,1.57,10.45,0,.67.01,2.28.01,2.28,0,.71-.01,1.41-.01,2.08-.01,5.37-.02,10.45-1.57,10.45-.95,0-1.22-.4-1.69-1.13-.52-.8-1.23-1.9-3-1.9-2.3,0-3.28,1.35-3.28,4.51,0,.19-.07,6.45-.11,9.74,0,3.72-2.95,6.73-6.57,6.73H9.74Z",
    style: {
      fill: "url(#linear-gradient-3)",
      isolation: "isolate",
      opacity: 0.33
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51,19.03c.97-1.43,2.39-2.21,4.23-2.32.11,0,.23-.01.33-.01,1.66,0,2.6.82,3.42,1.66,1.61,1.65,1.71,6.12,1.77,15.42,18.04,4.05,26.21-1.79,45.28-1.79,11.38,0,8.02.69,15.97,1.91,0-.24,0-.48,0-.72,0,0-.01-1.61-.01-2.28-.01-5.38-.02-10.45-1.57-10.45-.96,0-1.22.4-1.69,1.14-.52.8-1.23,1.89-3,1.89-2.3,0-3.28-1.35-3.28-4.5,0-.19-.07-6.45-.11-9.75,0-3.7-2.95-6.72-6.57-6.72H9.74c-3.8,0-7.25,3.2-7.25,6.72,0,0,.01,5.81.01,9.33,0,.18,0,.34,0,.49Z",
    style: {
      fill: "url(#linear-gradient-4)",
      isolation: "isolate",
      opacity: 0.76
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,49.01c0-.18,0-.34,0-.49.97,1.43,2.4,2.21,4.23,2.32.11,0,.23.01.33.01,1.66,0,2.6-.82,3.42-1.66,1.7-1.74,1.71-3.98,1.78-14.71v-.7c-.07,10.13-.12,12.31-1.78,14.01-.82.84-1.76,1.66-3.42,1.66-.11,0-.22,0-.33-.01-1.84-.11-3.26-.89-4.23-2.32,0,.16,0,.32,0,.49,0,3.52-.01,9.33-.01,9.33v.05c0-1.93.01-5.51.01-7.98ZM9.74,3.9h47.55c3.62,0,6.57,3.01,6.57,6.72.03,3.3.1,9.56.11,9.75,0,3.15.98,4.5,3.28,4.5,1.77,0,2.48-1.1,3-1.9.47-.73.74-1.14,1.69-1.14,1.54,0,1.55,5.08,1.57,10.45v1.62c0-.25,0-.49,0-.74,0,0-.01-1.61-.01-2.28-.01-5.38-.02-10.45-1.57-10.45-.95,0-1.22.4-1.69,1.14-.52.8-1.23,1.89-3,1.89-2.3,0-3.28-1.35-3.28-4.5,0-.19-.07-6.45-.11-9.75,0-3.7-2.95-6.72-6.57-6.72H9.74c-3.8,0-7.25,3.2-7.25,6.72v1.36c.03-3.5,3.47-6.67,7.25-6.67Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.69
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.99,56.95c-.82,0-1.65-.22-2.39-.63l-16.59-9.58c-1.48-.84-2.41-2.44-2.41-4.17v-19.14c0-1.71.92-3.31,2.4-4.17l16.57-9.58c1.52-.85,3.31-.84,4.8,0l16.6,9.58c1.48.86,2.4,2.46,2.4,4.17v19.14c0,1.73-.92,3.33-2.41,4.18l-16.58,9.57c-.76.42-1.58.64-2.41.64ZM22.61,41.88l15.39,8.89,15.39-8.89v-17.76l-11.13-6.42h-8.53l-11.13,6.42v17.76ZM38,13.04h0s0,0,0,0Z",
    style: {
      fill: "#ab55a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.31,20.41l-6.99-4.04-1.08-.62-8.5-4.91c-.56-.31-1.14-.47-1.74-.47s-1.2.16-1.74.47l-8.48,4.91-1.08.62-7.01,4.04c-1.08.62-1.74,1.78-1.74,3.02v19.14c0,1.25.66,2.41,1.74,3.02l16.57,9.57c.55.31,1.14.47,1.74.47s1.18-.16,1.74-.47l16.57-9.57c1.08-.61,1.74-1.77,1.74-3.02v-19.14c0-1.24-.66-2.39-1.74-3.02ZM38,11.71c.74,0,1.34.61,1.34,1.34,0,.45-.21.85-.57,1.09-.21.16-.49.25-.77.25-.31,0-.57-.09-.77-.25-.36-.24-.57-.64-.57-1.09,0-.73.61-1.34,1.34-1.34ZM54.72,41.99c0,.41-.23.78-.57.98l-15.57,9c-.35.2-.8.2-1.14,0l-15.57-9c-.35-.2-.57-.57-.57-.98v-17.99c0-.4.23-.78.57-.98l11.52-6.65h9.26l11.52,6.65c.35.2.57.59.57.98v17.99Z",
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72,24v17.99c0,.41-.23.78-.57.98l-15.57,9c-.35.2-.8.2-1.14,0l-15.57-9c-.35-.2-.57-.57-.57-.98v-17.99c0-.4.23-.78.57-.98l11.52-6.65h9.26l11.52,6.65c.35.2.57.59.57.98Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,38.12c-2.82,0-5.12-2.3-5.12-5.12s2.3-5.12,5.12-5.12,5.12,2.3,5.12,5.12-2.3,5.12-5.12,5.12ZM38,30.35c-1.46,0-2.65,1.19-2.65,2.65s1.19,2.65,2.65,2.65,2.65-1.19,2.65-2.65-1.19-2.65-2.65-2.65Z",
    style: {
      fill: "#ab55a1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 33,
    r: 3.88,
    style: {
      fill: "#34332b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E_-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 32.99,
    r: 2.02,
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.6ce0ad3edbf283ebf4246f2ab33a3c12.svg";
export { ForwardRef as ReactComponent };